import { ParagraphSM } from '@/atoms/Text'
import { useTranslate } from '@/utils/translate/translate-client'
import { CheckInputButton } from '../../components/CheckInputButton'
import { Page } from '../../components/Page'
import { PageHeading } from '../../components/PageHeading'
import { TorchApplicationTypes, useTorchApplication } from '../../components/TorchApplicationContext'
import { useDelayedSelection } from '../../components/useDelayedSelection'
import { filterApprovedTorchApplications } from './torchApplicationHelpers'

export const FullFilm = () => {
  const { t } = useTranslate('guild-create')
  const { torchApplications, updateType } = useTorchApplication()
  const [selection, onClick] = useDelayedSelection((id) => {
    updateType(TorchApplicationTypes.FullFilm, id === 'new' ? undefined : id)
  })

  const approvedApplications = filterApprovedTorchApplications(torchApplications)

  return (
    <Page>
      <div className="flex flex-col items-center gap-2">
        <PageHeading>{t('fullLengthFilmSubmission', 'Full Length Film Submission')}</PageHeading>
        <ParagraphSM>
          {t(
            'whatProjectDoYouWantToSubmitACompletedFullLengthFilmFor',
            'What project do you want to submit a completed full length film for?',
          )}
        </ParagraphSM>
      </div>

      {approvedApplications.map((appl) => {
        if (!appl) return null
        return (
          <CheckInputButton
            key={appl.id}
            name={appl.id}
            selected={selection === appl.id}
            onClick={onClick}
            className="!w-5/6 px-3 lg:!w-2/3"
          >
            <div className="flex w-full flex-row items-center gap-4">{appl.data?.title}</div>
          </CheckInputButton>
        )
      })}

      <CheckInputButton name="new" selected={selection === 'new'} onClick={onClick} className="!w-5/6 px-3 lg:!w-2/3">
        <div className="flex w-full flex-row items-center gap-4">Other Project</div>
      </CheckInputButton>
    </Page>
  )
}
